<template>
  <div>
    <v-menu offset-y transition="slide-y-transition" class="help-menu">
      <template v-slot:activator="{ on, attrs }">
        <div class="d-flex justify-center">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon color="grey darken-1">fa-solid fa-circle-question</v-icon>
          </v-btn>
        </div>
      </template>

      <div class="help-container">
        <div class="help-content">
          <div v-for="item in items" :key="item.id">
            <div
              class="align-center menu-item px-4 py-2 d-flex align-center my-2"
              :class="item.divider ? 'menu-divider' : ''"
            >
              <a
                v-if="item.id === 3"
                @click="aboutClicked()"
                target="_blank"
                class="text-link"
              >
                <i :class="item.icon"></i>
                <span> {{ item.text }}</span>
              </a>
              <a v-else :href="item.link" target="_blank" class="text-link">
                <i :class="item.icon"></i>
                <span> {{ item.text }}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </v-menu>
  </div>
</template>
<script>
export default {
  data() {
    return {
      items: [
        {
          id: 1,
          link: "https://doc.nexusgroup.com/",
          icon: "fa-light fa-file-circle-question icon-color fa-xl pr-1",
          text: "Documentation",
          divider: false,
        },
        {
          id: 2,
          link: "https://www.nexusgroup.com/support/",
          icon: "fa-light fa-headset icon-color fa-xl pr-1",
          text: "Contact support",
          divider: false,
        },
        {
          id: 3,
          link: "",
          icon: "fa-light fa-circle-info icon-color fa-xl pr-1",
          text: "About CM Web UI",
          divider: true,
        },
      ],
    };
  },
  methods: {
    aboutClicked() {
      this.$emit("openAbout");
    },
  },
};
</script>
<style lang="scss">
.help-menu {
  z-index: 999;
}
.help-container {
  background-color: #ffffff;
  overflow-y: auto;
}
.help-content {
  width: 15rem;
}
.icon-color {
  color: #5e6466;
}
.menu-item:hover {
  background-color: #ececec;
  cursor: pointer;
}
.text-link {
  text-decoration: none;
}
.menu-divider {
  border-top: 1px solid #e8e8e8;
}
</style>
